// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/create-portfolio/app/css/app.css
// module id = 807
// module chunks = 0